import { Button } from "components/ui/button";
import { QuizOption } from "./form-fields/quiz-option";
import Results from "./results";
import { ChevronLeft } from "components/common/icons";
import Simulator from "../common/simulator";
import Disclaimer from "../common/disclaimer";
import useQuiz from "hooks/useQuiz";
import { getGTMProps } from "types/common";
import styles from "./simulator-form.module.css";
import { cn } from "lib/utils";

interface SimulatorFormProps {
  questions: {
    questionType: string;
    questionId: string;
    maxNumOfAnswer: number;
    displayConfiguration: {
      title: string;
      isRequired?: boolean;
      choices: {
        number: number;
        value: string;
        icon: string;
        description: string;
        score: number;
      }[];
    };
  }[];
}

export function SimulatorForm({ questions: quizSteps }: SimulatorFormProps) {
  const gtmProps = getGTMProps("family");

  const {
    formStep,
    quizCurrentStep,
    answers,
    currentStepData,
    currentAnswer,
    isLastStep,
    handleOptionSelect,
    handleNext,
    handleBack,
  } = useQuiz(quizSteps, gtmProps);

  const isRequired = currentStepData.displayConfiguration.isRequired ?? true;
  const totalSteps = quizSteps.length + 1;

  return (
    <Simulator>
      <div className={styles.container}>
        <div
          className={cn(
            styles.innerContainer,
            formStep === 1 && styles.step1Container,
          )}
        >
          <div className={styles.textCenter}>
            <div className={styles.stepText}>
              Step {formStep === 1 ? quizCurrentStep : quizSteps.length + 1} of{" "}
              {totalSteps}
            </div>
            {formStep === 1 && (
              <div>
                <h2 className={styles.titleText}>
                  {currentStepData.displayConfiguration.title}
                </h2>
              </div>
            )}
          </div>

          {formStep === 1 && (
            <>
              <div className={styles.gridContainer}>
                {currentStepData.displayConfiguration.choices.map(
                  (option, index) => (
                    <QuizOption
                      key={index}
                      icon={option.icon}
                      title={option.value}
                      description={option.description}
                      isSelected={currentAnswer?.answers.some(
                        (answer) => answer.number === option.number,
                      )}
                      onClick={() => handleOptionSelect(option, !isRequired)}
                    />
                  ),
                )}
              </div>

              <div className={styles.buttonContainer}>
                {quizCurrentStep > 1 && (
                  <Button
                    variant={"secondary"}
                    size={"sm"}
                    className={styles.buttonBack}
                    onClick={handleBack}
                  >
                    <ChevronLeft />
                    Back
                  </Button>
                )}
                <Button
                  onClick={handleNext}
                  disabled={isRequired && !currentAnswer?.answers.length}
                >
                  {isLastStep ? "View Results" : "Next"}
                </Button>
              </div>
            </>
          )}

          {formStep === 2 && <Results quizAnswers={answers} />}

          <div>
            <Disclaimer page="family" />
          </div>
        </div>
      </div>
    </Simulator>
  );
}
